
import { debounce } from "lodash";
import { defineComponent, ref, watch } from "vue";

export default defineComponent({
  name: "AreaNameInput",

  props: {
    modelValue: {
      type: String,
      default: "",
    },
    existingAreaNames: {
      type: Array as () => Array<{ formId: string; areaName: string }>,
      default: () => [],
    },
    formId: {
      type: String,
      required: false,
    },
  },

  emits: ["update:modelValue", "validation"],

  setup(props, { emit }) {
    const validationError = ref<string>("");
    const touched = ref<boolean>(false);

    const validate = (value: string): string => {
      const name = value.trim();
      const lowerName = name.toLowerCase();

      if (!name) {
        return "Nama area harus diisi";
      }
      if (name.length < 3) {
        return "Nama area minimal 3 karakter";
      }
      if (name.length > 100) {
        return "Nama area maksimal 100 karakter";
      }

      const isDuplicate = props.existingAreaNames.some((form) => {
        return (
          form.formId !== props.formId &&
          form.areaName?.trim().toLowerCase() === lowerName
        );
      });

      if (isDuplicate) {
        return "Nama area sudah digunakan";
      }
      return "";
    };

    const debouncedValidate = debounce(() => {
      const trimmedValue = props.modelValue.trimStart();
      emit("update:modelValue", trimmedValue);
      validationError.value = validate(trimmedValue);
      emit("validation", !validationError.value);
    }, 300);

    const onInput = (event: any) => {
      touched.value = true;
      const value = (event.target as HTMLInputElement).value.replace(/[^a-zA-Z0-9 ]/g, '');
      event.target.value = value;
      emit("update:modelValue", value);
      debouncedValidate();
    };

    const onBlur = () => {
      if (!touched.value) return;

      validationError.value = validate(props.modelValue);
      emit("validation", !validationError.value);
    };

    watch(
      () => props.existingAreaNames,
      () => {
        if (!touched.value) return;

        validationError.value = validate(props.modelValue);
        emit("validation", !validationError.value);
      },
      { deep: true }
    );

    return {
      validationError,
      onInput,
      onBlur,
    };
  },
});
